module.exports = __webpack_public_path__ + "static/img/loading.9d6c7e2.gif";


//////////////////
// WEBPACK FOOTER
// ./static/icons/loading.gif
// module id = F7J1
// module chunks = 1